import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useEffect } from 'react';
import { FullScreen, useFullScreenHandle } from "react-full-screen";

const DocViewerComp = ({ documents, show, ext }) => {
  const handle = useFullScreenHandle();

  // Keyboard navigation for Fullscreen
  useEffect(() => {
    if (!handle.active) return;
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        const btn = document.getElementById("pdf-pagination-next");
        if (btn && !btn.disabled) btn.click();
      } else if (e.key === "ArrowLeft") {
        const btn = document.getElementById("pdf-pagination-prev");
        if (btn && !btn.disabled) btn.click();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handle.active]);

  const docKeyNormal = (documents || []).map((doc) => doc.uri || doc.file?.name).join("_") + "_normal";
  const docKeyFull = (documents || []).map((doc) => doc.uri || doc.file?.name).join("_") + "_full";

  return (
    <>
      {!!documents?.length && (
        <div className="w-100 d-flex justify-content-end">
          <button className="btn btn-primary btn-sm" onClick={handle.enter}>
            <i className="fa fa-expand"></i>
          </button>
        </div>
      )}
      {!handle.active && (
        <div style={{ height: "450px", position: "relative" }}>
          <DocViewer
            key={docKeyNormal}
            documents={documents}
            pluginRenderers={DocViewerRenderers}
            config={{
              header: { disableHeader: true },
              pdfVerticalScrollByDefault: false,
            }}
            style={{ height: "100%" }}
            className="doc-viewer"
          />
        </div>
      )}
      <FullScreen handle={handle}>
        {handle.active && (
          <div style={{
            width: '100vw',
            height: '100vh',
            backgroundColor: '#525659',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'hidden'
          }}>

            {(ext === "ppt" || ext === "doc" || ext?.includes("docx") || ext?.includes("pptx")) && (
              <div className="doc-overlay-full"></div>
            )}

            <div style={{ width: '100%', height: '100%' }}>
              <DocViewer
                key={docKeyFull}
                documents={documents}
                pluginRenderers={DocViewerRenderers}
                config={{
                  header: { disableHeader: true },
                  pdfVerticalScrollByDefault: false,
                }}
                className="doc-viewer"
              />
            </div>
          </div>
        )}
      </FullScreen>
    </>
  );
};

export default DocViewerComp;